import { render, staticRenderFns } from "./FuncionarioSolicitudNacionalesIndex.vue?vue&type=template&id=1925073c"
import script from "./FuncionarioSolicitudNacionalesIndex.vue?vue&type=script&lang=js"
export * from "./FuncionarioSolicitudNacionalesIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports